import {makeType, actionCreator} from '../../Utils/generateActionCreator';
import { API } from "aws-amplify";

const actionType = makeType("CONFIG");

export const ADD_AS = actionType('ADD_AS');
export const ADD_RI = actionType('ADD_RI');
export const ADD_RG = actionType('ADD_RG');
export const ADD_IG = actionType('ADD_IG');
export const ADD_UC = actionType('ADD_UC');
export const ADD_PRODUCTOS_FLAG_CANCELAR = actionType('ADD_PRODUCTOS_FLAG_CANCELAR');

export const addAS = actionCreator(ADD_AS, "AS");
export const addRI = actionCreator(ADD_RI, "RI");
export const addRG = actionCreator(ADD_RG, "RG");
export const addIG = actionCreator(ADD_IG, "IG");
export const addUC = actionCreator(ADD_UC, "UC");
export const addProductosFlagCancelar = actionCreator(ADD_PRODUCTOS_FLAG_CANCELAR, "productosFlagCancelar");

export const getConfigAS = async (dispatch) => {
  const response = await API.get('api-rentas', '/producto/configmin/AS'); // entrando
  if (response) dispatch(addAS(response));
};

export const getConfigRI = async (dispatch) => {
  const response = await API.get('api-rentas', '/producto/configmin/RI'); // entrando
  if (response) dispatch(addRI(response));
};

export const getConfigRG = async (dispatch) => {
  const response = await API.get('api-rentas', '/producto/configmin/RG'); // se llama en varios
  if (response) dispatch(addRG(response));
};

export const getConfigIG = async (dispatch) => {
  const response = await API.get('api-rentas', '/producto/configmin/IG');
  if (response) dispatch(addIG(response));
};

export const getConfigUC = async (dispatch) => {
  const response = await API.get('api-rentas', '/producto/configmin/UC');
  if (response) dispatch(addUC(response));
};
